import React from 'react';
import TreatmentPlanFormPage from "./TreatmentPlanFormPage"

const TreatmentPlanCreate = () => {
  console.log('TreatmentPlanCreate component loaded');
  
  return (
    <div style={{ width: '100%' }}>
      <TreatmentPlanFormPage />
    </div>
  )
}

export default TreatmentPlanCreate